export const PROFILE_REMINDER = 'btn_profile_reminder';
export const NEW_USER = 'btn_new_user';
export const DATE_FORMAT = 'YYYY-MM-DD';
